import gql from 'graphql-tag';

export const CREATE_COUPON = gql`
  mutation CreateCoupon($input: CouponIntput!) {
    createCoupon(input: $input) {
      _id
      code
    }
  }
`;

export const UPDATE_COUPON = gql`
  mutation UpdateCoupon($updateCouponId: MOID!, $input: CouponUpdateInput!) {
    updateCoupon(id: $updateCouponId, input: $input)
  }
`;
